import React, { useState, useEffect } from 'react';
import './ActiveUsersCounter.css';
import { subscribeToActiveUsers, initializePresence } from '../services/activeUsersService';

const ActiveUsersCounter = () => {
  const [activeUsers, setActiveUsers] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize presence system
    const cleanupPresence = initializePresence();

    // Subscribe to active users count
    const unsubscribe = subscribeToActiveUsers((count) => {
      setActiveUsers(count);
      setLoading(false);
    });

    // Cleanup on unmount
    return () => {
      cleanupPresence();
      unsubscribe();
    };
  }, []);

  const getStatusColor = () => {
    if (activeUsers === 0) return '#ff6b6b'; // Red for no users
    if (activeUsers < 5) return '#ffd93d'; // Yellow for few users
    return '#6bcf7f'; // Green for active community
  };

  const getStatusText = () => {
    if (activeUsers === 0) return 'No one online';
    if (activeUsers === 1) return '1 user online';
    return `${activeUsers} users online`;
  };

  if (loading) {
    return (
      <div className="active-users-counter loading">
        <div className="status-dot" style={{ backgroundColor: '#ccc' }}></div>
        <div className="counter-text">Loading...</div>
      </div>
    );
  }

  return (
    <div className="active-users-counter">
      <div
        className="status-dot"
        style={{ backgroundColor: getStatusColor() }}
      ></div>
      <div className="counter-text">
        <span className="counter-number">{activeUsers}</span>
        <span className="counter-label">online</span>
      </div>
    </div>
  );
};

export default ActiveUsersCounter;
